// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__wyPz4","logo":"MainNavigation_logo__aTMK-"};